<template>
    <transition appear name="fade-transition">
        <v-menu
            v-model="menu"
            offset-y
            transition="slide-y-transition"
            :close-on-content-click="false"
            height="30rem"
            width="20rem"
        >
            <template #activator="{ on, attrs }">
                <v-btn
                    v-test-id="'platform-button-switch_user'"
                    x-large
                    depressed
                    text
                    color="primaryBackground"
                    class="px-1 align-self-center text-transform-none"
                    v-bind="attrs"
                    v-on="on"
                >
                    <div class="d-flex flex-row ml-2">
                        <div class="d-flex mr-2">
                            <v-icon color="primaryBackground" :class="menu ? 'fa-rotate-90' : false">
                                {{ getIcon('expand') }}
                            </v-icon>
                        </div>
                        <div class="d-flex flex-column justify-center align-end mr-3">
                            <p class="mb-0 body-2 primaryText--text">{{ title }}</p>
                            <p class="mb-0 caption">{{ subtitle }}</p>
                        </div>
                        <v-avatar color="transparent" size="3rem">
                            <v-img contain :src="Auth().branding().image('avatar')" max-height="90%" max-width="90%" />
                        </v-avatar>
                    </div>
                </v-btn>
            </template>

            <div class="background">
                <app-account-switcher-list />
                <div class="pa-4 background darken-1">
                    <v-layout justify-space-between>
                        <app-button
                            test-id="platform-button-settings"
                            :icon-left="isInvestor() ? 'user' : 'settings'"
                            :text="isInvestor() ? $t('my_account') : $t('settings')"
                            secondary
                            :to="{ name: 'Settings' }"
                            @click="menu = false"
                        />
                        <app-logout-button v-test-id="`platform-button-logout`" @click="menu = false" />
                    </v-layout>

                    <template v-if="!isLive()">
                        <app-divider class="mt-4" hidden />

                        <v-layout justify-space-between align-center>
                            <app-toggle-mock-api />
                            <app-button
                                text="Clear Mock Data"
                                secondary
                                class="ml-2"
                                @click="
                                    menu = false;
                                    $store.dispatch('app/clearMockData');
                                "
                            />
                        </v-layout>
                    </template>
                </div>
            </div>
        </v-menu>
    </transition>
</template>

<script>
import isLive from '@/lib/helpers/isLive';

export default {
    name: 'AppAccountSwitcher',
    components: {
        AppAccountSwitcherList: () =>
            import(
                /* webpackChunkName: "core" */
                '@/components/AppAccountSwitcherList'
            ),
        AppToggleMockApi: () =>
            import(
                /* webpackChunkName: "core" */
                '@/components/AppToggleMockApi'
            )
    },
    data: () => ({
        menu: false,
        isLive
    }),
    computed: {
        title() {
            // if (this.isInvestor()) {
            //     return this.Auth().organisation.name;
            // }

            return this.Auth().user.name;
        },
        subtitle() {
            // if (this.isInvestor()) {
            //     return this.Auth().organisation.name;
            // }

            return this.Auth().organisation.name;
        }
    }
};
</script>
